import { createTokenRefreshingAxiosInstance } from 'API_LAYER/refreshToken'
import axios from 'axios'

const axInstance = createTokenRefreshingAxiosInstance(axios.create())

export { axInstance as axios }
